import { MessageSquare, Trash2 } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SidebarGroupLabel } from '@/components/ui/sidebar';

export default function ConversationGroup({ label, conversations, onDelete }) {
  const navigate = useNavigate();
  const { threadId: activeThreadId } = useParams();
  const { t } = useTranslation('chat');

  if (conversations.length === 0) return null;

  return (
    <div className="px-2 mb-1">
      <SidebarGroupLabel className="px-1 text-[11px] uppercase tracking-wider text-sidebar-foreground/50">
        {label}
      </SidebarGroupLabel>
      <div className="space-y-0.5">
        {conversations.map((conv) => (
          <div
            key={conv.thread_id}
            onClick={() => navigate(`/chat/${conv.thread_id}`)}
            className={`group flex items-center gap-2 px-2 py-1.5 text-sm rounded-md cursor-pointer transition-colors ${
              activeThreadId === conv.thread_id
                ? 'bg-sidebar-accent text-sidebar-accent-foreground'
                : 'hover:bg-sidebar-accent/50 text-sidebar-foreground'
            }`}
          >
            <MessageSquare className="size-3.5 shrink-0 text-muted-foreground" />
            <span className="truncate flex-1 text-[13px]">
              {conv.title || t('untitled', 'Untitled conversation')}
            </span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete(conv.thread_id);
              }}
              className="opacity-0 group-hover:opacity-100 text-muted-foreground hover:text-destructive transition-all shrink-0"
            >
              <Trash2 className="size-3.5" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
